import React, { useEffect, useState } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'

import { doUpdateDomain } from '../../../redux/actions/domain'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { toast } from '../../CommonComponents/ToastComponent/toast'

const DomainDetailModal = ({ show, onClose, domainColumns, selectedDomain, showEdit = false }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    domain: { isLoading },
  } = store

  const [domainInfo, setDomainInfo] = useState({})
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    if (!selectedDomain) {
      return
    }
    const tmpDomainInfo = {}
    domainColumns.forEach(domain => {
      tmpDomainInfo[domain.value] = selectedDomain[domain.value]
    });
    setDomainInfo(tmpDomainInfo)
  }, [selectedDomain, domainColumns])

  const handleClickSave = () => {
    setIsEdit(false)
    if (domainInfo?.domainName === '') {
      toast.show({
        title: 'Warning',
        description: 'Domain name is required',
      })
      return
    }
    if (domainInfo?.companyName === '') {
      toast.show({
        title: 'Warning',
        description: 'Company name is required',
      })
      return
    }
    if (domainInfo?.address1 === '' && domainInfo?.address2 === '') {
      toast.show({
        title: 'Warning',
        description: 'Address is required',
      })
      return
    }
    if (domainInfo?.city === '') {
      toast.show({
        title: 'Warning',
        description: 'City is required',
      })
      return
    }
    if (domainInfo?.state === '') {
      toast.show({
        title: 'Warning',
        description: 'State is required',
      })
      return
    }
    if (domainInfo?.zip === '') {
      toast.show({
        title: 'Warning',
        description: 'Zip is required',
      })
      return
    }
    if (domainInfo?.country === '') {
      toast.show({
        title: 'Warning',
        description: 'Country is required',
      })
      return
    }
    if (domainInfo?.url === '') {
      toast.show({
        title: 'Warning',
        description: 'URL is required',
      })
      return
    }
    if (domainInfo?.phone === '') {
      toast.show({
        title: 'Warning',
        description: 'Phone is required',
      })
      return
    }
    if (domainInfo?.industry === '') {
      toast.show({
        title: 'Warning',
        description: 'Industry is required',
      })
      return
    }
    if (domainInfo?.companySize === '') {
      toast.show({
        title: 'Warning',
        description: 'Company size is required',
      })
      return
    }
    dispatch(
      doUpdateDomain({
        ...domainInfo,
        userRoleId: selectedDomain?.userRoleId,
        domainId: selectedDomain?.domainId,
      })
    )
  }

  const handleChangeDomainInfo = (domain, value) => {
    setDomainInfo({
      ...domainInfo,
      [domain.value]: value,
    })
  }

  return (
    <Modal
      backdrop={'static'}
      className="domain-detail-modal"
      show={show}
      size="lg"
      onClick={() => { setIsEdit(false); onClose() }}
      onHide={() => { setIsEdit(false); onClose() }}
    >
      <Modal.Header>
        <Modal.Title className='fw-bold text-black'>
          Domain Information Modal
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`domain-info ${isLoading ? 'loading' : ''}`}>
          {isLoading && <LoaderComponent />}
          <div className="card domain-detail">
            {/* <div className="card-header">
              {
                showEdit && (
                  <div className="tool">
                    {
                      isEdit && (
                        <button type="button" className="card-edit-button" onClick={handleClickSave}>SAVE</button>
                      )
                    }
                    {
                      !isEdit && (
                        <button type="button" className="card-edit-button" onClick={() => { setIsEdit(true) }}>EDIT</button>
                      )
                    }
                  </div>
                )
              }
            </div> */}
            <div className="card-content list">
              {
                domainColumns.map(domain => (
                  <div className="item" key={domain.value}>
                    <h5 className="label w-50">{domain.label}</h5>
                    <input type="text"
                      className='search-input'
                      defaultValue={domainInfo[domain.value] || ''}
                      onChange={e => handleChangeDomainInfo(domain, e.target.value)}
                      disabled={!isEdit}
                    />
                    {/* {
                      !isEdit && (
                        <span className="value">{domainInfo[domain.value] || ''}</span>
                      )
                    }
                    {
                      isEdit && (
                        <input type="text" defaultValue={domainInfo[domain.value] || ''} onChange={e => handleChangeDomainInfo(domain, e.target.value)} />
                      )
                    } */}
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {
          showEdit && (
            <div className="tool">
              {
                isEdit && (
                  <button type="button" className="btn-green h4 mb-0 p-5 pt-2 pb-2 rounded" onClick={handleClickSave}>Save</button>
                )
              }
              {
                !isEdit && (
                  <button type="button" className="btn-green h4 mb-0 p-5 pt-2 pb-2 rounded" onClick={() => { setIsEdit(true) }}>Edit</button>
                )
              }
            </div>
          )
        }
      </Modal.Footer>
    </Modal>
  )
}

export default DomainDetailModal